module.exports = __webpack_public_path__ + "static/media/latrine.c0060cfb.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/latrine.JPG
// module id = 773
// module chunks = 0